export default __webpack_public_path__ + "static/media/6.4b2e4edb.jpg";